<template>
  <b-container class="card-container">
    <b-card>
      <template v-slot:header>
        <span class="breadcrumbs"><b-link :to="{name: `voices`}">{{collection | capitalise | pluralise}}</b-link> / Create</span>
      </template>

      <b-form @submit.stop.prevent="create_item">
        <b-form-group label="Name:" invalid-feedback="Must be greater then 4 character">
          <b-form-input v-model="item.name" required placeholder="e.g. John" :state="validate_state('name')"></b-form-input>
        </b-form-group>

        <b-form-group label="Description:">
          <b-form-input v-model="item.description" placeholder="A deep voice..."></b-form-input>
        </b-form-group>

        <b-form-group label="Provider">
          <b-form-select v-model="item.provider" required :options="['descript', 'synthesia']"></b-form-select>
        </b-form-group>

        <div v-if="item.provider === 'synthesia'">
          <b-form-group label="Provider ID:" >
            <b-form-input v-model="item.provider_id" required></b-form-input>
          </b-form-group>

          <b-form-group label="Language code">
            <b-form-input v-model="item.language" required placeholder='en'></b-form-input>
          </b-form-group>

          <b-form-group label="Accent code">
            <b-form-input v-model="item.accent" required placeholder='en-US'></b-form-input>
          </b-form-group>

          <b-form-group label="Gender">
            <b-form-select v-model="item.gender" required :options="['male', 'female']"></b-form-select>
          </b-form-group>
        </div>

        <!-- <h4>Descript</h4>
        <b-form-group label="Username:">
          <b-form-input v-model="item.descript_username" required placeholder="john@example.com"></b-form-input>
        </b-form-group>
        <b-form-group label="Password:">
          <b-form-input v-model="item.descript_password" required placeholder="*********" ></b-form-input>
        </b-form-group> -->

        <!-- <h3>Training data</h3>
        <p>Submit audio training data to learn your voice</p>
        <ul>
          <li>Read using the same tone, energy level and delivery style you wish your Overdub voice to have.</li>
          <li>Don't worry if you make mistakes, just keep going. </li>
          <li>If you wish to stop and continue the next day, no problem, just pick it up from where you left off.</li>
          <li>You must record at least ten minutes, but for best results, we recommend completing the Main Script, which takes about 30 minutes.</li>
        </ul>

        <p>Read the script and record your voice (in WAV format), once done, upload here</p>
        <b-button href="https://coda.io/@overdub/overdub-scripts/main-script-61" target="_blank" class="mb-2">Open the script</b-button>
        <b-form-group>
          <b-form-file v-model="file" placeholder="Choose a Audio file" drop-placeholder="Drop file here..." accept="audio/*"></b-form-file>
        </b-form-group> -->

        <LoadingButton type="submit" variant='primary' :loading="is_saving">Save</LoadingButton>
      </b-form>

    </b-card>
  </b-container>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"
import { db, storage, FieldValue } from '@/main.js'
import scripts from '@/assets/scripts.json'

export default {
  metaInfo: {title: 'Clone create'},
  props: ['profile'],
  mixins: [ItemMixin],
  validations: {
    item: {
      name: {required, minLength: minLength(3)},
    }
  },
  firestore: function () {
    return {
      _item: db.collection(this.collection).doc()
    }
  },
  data() {
    let script = []
    for (let line of scripts) {
      script.push({text: line, audio_url: null})
    }

    return {
      collection: 'voice',
      file: null,
      item: {
        name: '',
        status: 'training',
        provider: 'synthesia',
        provider_id: null,
        description: '',
        training_audio_url: null,
        descript_voice_id: null,
        descript_username: null,
        descript_password: null,
        language: 'en',
        accent: 'en-US',
        gender: 'male',
        script: script,
        public: false
      },
    }
  },
  methods: {
    async do_before() {
      if (this.item.provider === 'synthesia') {
        this.item.status = 'complete'
        this.script = []
      }

      return true
    },
    async do_after() {
      await db.collection('user').doc(this.profile.id).update({updated: new Date(), voices_count: FieldValue.increment(1)})
    }
  }
}
</script>

<style>

</style>
